import { Router } from '@angular/router';
import { AuthService } from './auth.service';
var LoginGuard = /** @class */ (function () {
    function LoginGuard(auth, router) {
        this.auth = auth;
        this.router = router;
    }
    LoginGuard.prototype.canActivate = function () {
        if (this.auth.loggedIn()) {
            this.router.navigate(['/dashboard']);
        }
        return true;
    };
    return LoginGuard;
}());
export { LoginGuard };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/login-guard.service.ts.pre-build-optimizer.js